<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <crm-nav></crm-nav>
    <div class="team_box">
      <div
        class="team"
        :style="{ minHeight: MHeight, boxSizing: 'border-box' }"
      >
        <!-- tab切换 -->
        <div class="team_tab">
          <span
            :style="{
              color: active == '1' ? '#5B85FF' : '#0A101E',
              borderBottom: active == '1' ? '2px solid #5B85FF' : 'none'
            }"
            @click="team"
            >团队成员</span
          >
          <span
            :style="{
              color: active == '2' ? '#5B85FF' : '#0A101E',
              borderBottom: active == '2' ? '2px solid #5B85FF' : 'none'
            }"
            @click="apply"
            >审批申请</span
          >
        </div>
        <!-- 成员信息 -->
        <div class="teamList" v-if="active == '1' ? true : false">
          <div
            class="add"
            :style="{ borderColor: borderColor }"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
          >
            <div
              class="yuan"
              :style="{ background: borderColor }"
              @click="invitation"
            >
              <i :style="{ color: iColor }" class="el-icon-plus"></i>
            </div>
            <p>邀请成员</p>

            <div class="qxbz" v-show="qxShow">
              <div class="yuan1">
                <i style="color: #ff4f4f;" class="iconfont icon-quanxian"></i>
              </div>
              <p style="color: #ff4f4f;margin-top: -20px;font-size: 16px;">
                权限不足
              </p>
            </div>
          </div>

          <div class="teamItem" v-for="(item, index) in t_list" :key="index">
            <!-- 头部个人信息 -->
            <div class="user_msg">
              <div class="itemTop">
                <div style>
                  <img
                    v-if="!item.selfImage"
                    style="width: 64px;height: 64px;border-radius: 50%;margin-right: 14px;"
                    src="../../../assets/images/crm/nan.png"
                    alt=""
                  />
                  <img
                    v-if="item.selfImage"
                    :style="{
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      marginRight: '14px',
                      border: item.adLevel == 0 ? '1px solid #f0c264' : 'none'
                    }"
                    :src="api + item.selfImage"
                    alt=""
                  />
                  <i
                    v-if="item.adLevel == 0"
                    class="iconfont icon-huangguan"
                  ></i>
                </div>

                <div
                  style="display: flex;align-items: center;flex-wrap: wrap;padding: 10px 0;"
                >
                  <span>{{ item.name }}</span>
                  <span
                    style="color: #ffd25a;font-size: 16px;margin-left: 5px;"
                    v-if="item.adLevel == 0 ? true : false"
                    class="iconfont icon-chaojiguanliyuan2"
                  ></span>
                  <!-- <div v-if="item.adLevel == 0 ? true : false" class="superImg">
                    超级管理员
                  </div> -->

                  <p style="width: 100%;">
                    <i class="iconfont icon-shouji01"></i>
                    {{ item.phone }}
                  </p>
                </div>
                <div
                  class="delBox"
                  style="text-align: right;flex: 1;margin-top: -10px;"
                >
                  <i
                    v-show="
                      item.adLevel == 1 && res.adLevel == 0 ? true : false
                    "
                    class="iconfont icon-shanchu decoration1"
                    style="color: #5b85ff;cursor: pointer;margin-right: 5px;"
                    @click="del_btn(item.name, item.id)"
                    >&nbsp;</i
                  >
                </div>
              </div>
              <!-- <img
                v-show="item.adLevel == 1 && res.adLevel == 0 ? true : false"
                style="position: absolute;width: 25px;height:25px;top: -2px;right: -2px;cursor: pointer;"
                @click="del_btn(item.name, item.id)"
                src="../../../assets/images/crm/yuan.png"
                alt=""
              /> -->
              <!-- <i
                v-show="item.adLevel == 1 && res.adLevel == 0 ? true : false"
                style="position: absolute;font-size: 22px;color: #FF6050;top: -2px;right: -2px;cursor: pointer;"
                class="iconfont icon-shanchu"
                @click="del_btn(item.name, item.id)"
                class="el-icon-more"
              ></i> -->
            </div>

            <!-- 管理模块 -->
            <p class="modular">管理权限</p>
            <div class="modularI">
              <span
                :style="{
                  marginRight: '10px',
                  color: !e.selected ? '#868e99' : '',
                  width: '87px',
                  display: 'flex'
                }"
                v-for="(e, i) in item.list"
                v-if="item.adLevel == 1 && e.selected"
                :key="i"
              >
                <i
                  style="font-size: 12px;margin-top: 2px;"
                  class="iconfont icon-yuechi_"
                ></i>
                <i style="display: inline-block;">{{ e.name }}</i>
                <!-- <i
                  v-if="!e.selected"
                  style="display: inline-block;width: 10px;height: 10px;border: 1px solid #DCDCDC;border-radius: 2px;"
                ></i> -->
              </span>
              <span
                :style="{
                  marginRight: '10px',
                  color: !e.selected ? '#868e99' : '',
                  width: '87px',
                  display: 'flex'
                }"
                v-if="item.adLevel == 0"
                v-for="(e, i) in item.list"
                :key="i"
              >
                <i
                  style="font-size: 12px;margin-top: 2px;"
                  class="iconfont icon-yuechi_"
                ></i>
                <i style="display: inline-block;">{{ e.name }}</i>
              </span>
            </div>
            <div
              v-show="item.adLevel == 1 && res.adLevel == 0 ? true : false"
              class="editBtn"
            >
              <div class="hoverIcon" style="padding-bottom: 1px;">
                <i
                  class="iconfont icon-quanxianshezhi"
                  @click="qx_edit(item.customerId, item.id, '3')"
                  >&nbsp;</i
                ><em @click="qx_edit(item.customerId, item.id, '3')"
                  >权限设置</em
                >
              </div>

              <div class="hoverIcon" style="padding-bottom: 1px;">
                <i
                  style="font-size: 17px;"
                  class="iconfont icon-a-tubiao_wupin-wendangshezhi_renwuguanli_xian"
                  @click="qx_edit(item.customerId, item.id, '4')"
                  >&nbsp;</i
                ><em @click="qx_edit(item.customerId, item.id, '4')"
                  >合作方设置</em
                >
              </div>

              <div class="hoverIcon" style="padding-bottom: 1px;">
                <i
                  style="font-size: 18px;"
                  class="iconfont icon-quanxianshezhi1"
                  @click="qx_edit(item.customerId, item.id, '5')"
                  >&nbsp;</i
                ><em @click="qx_edit(item.customerId, item.id, '5')"
                  >账号设置</em
                >
              </div>
            </div>
            <!-- 权限修改 -->
            <!-- <div
              class="edit"
              v-show="item.adLevel == 1 && res.adLevel == 0 ? true : false"
              @click="qx_edit(item.customerId, item.id)"
            >
              权限修改
            </div> -->
          </div>
        </div>

        <!-- 审批申请 -->
        <div class="teamList" v-if="active == '2' ? true : false">
          <div
            v-if="spList.length <= 0"
            style="text-align: center;margin-left: 66px;margin-top: 20px;"
          >
            <img src="../../../assets/images/crm/weishenpi.png" alt="" />

            <p style="color: #d8dde9;font-size: 18px;margin-top: 10px;">
              暂无申请
            </p>
          </div>

          <div class="teamItem" v-for="(item, index) in spList" :key="index">
            <!-- 头部个人信息 -->
            <div class="itemTop">
              <div class="img_box">
                <img
                  v-if="!item.selfImage"
                  style="width: 64px;height: 64px;display: block;border-radius: 50%;margin-right: 14px;"
                  src="../../../assets/images/crm/nan.png"
                  alt=""
                />
                <img
                  v-if="item.selfImage"
                  style="width: 64px;height: 64px;object-fit: cover;border-radius: 50%;margin-right: 14px;"
                  :src="api + item.selfImage"
                  alt=""
                />
              </div>
              <div class="user_msg" style="padding-top: 15px;">
                <span>{{ item.name }}</span>
                <p style="margin-top: 5px;">
                  <i class="iconfont icon-shouji01"></i> {{ item.phone }}
                </p>
              </div>
            </div>

            <!-- 申请时间 -->
            <p
              class="modular"
              style="margin-left: 30px;margin-bottom: 15px;margin-top: 10px;"
            >
              申请时间：<span style="color: #181E2D;">
                {{ item.createTime }}</span
              >
            </p>

            <!-- 处理状态 -->
            <p
              class="modular"
              style="margin-top: 0;margin-left: 30px;margin-bottom: 10px;position: relative;"
            >
              处理状态：<span
                style="color: #FF6050;display: inline-block;width: 56px;background-color: #FFF8F6;
              border-radius: 11px;height: 22px;line-height: 22px;text-align: center;"
                >{{
                  item.state == 0
                    ? "待审批"
                    : item.state == 1
                    ? "审批通过"
                    : "审批拒绝"
                }}</span
              >
              <b
                style="font-size: 64px;color: #B8BABD;font-weight: normal;position: absolute;top: -140px;right: 10px;opacity: 0.4;"
                class="iconfont icon-shenpi"
              ></b>
            </p>
            <div class="shenpi_" @click="sp_btn(item.customerId, item.id)">
              <i class="iconfont icon-shenpi1"></i><span>审批</span>
            </div>
            <!-- 点击审批 -->
            <!-- <div class="edit" @click="sp_btn(item.id)">点击审批</div> -->
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <!-- 邀请管理员遮罩层 -->
      <div class="popContainer" v-show="admin" style="overflow-y:auto ;">
        <div
          class="add"
          :style="{
            width: '1000px',
            top: 0,
            transform: 'translate(-50%, -400px) !important'
          }"
        >
          <div class="close"></div>
          <div class="Top" :style="{ width: '1000px' }">
            添加
          </div>
          <span
            class="close iconfont icon-close_round_fill_bold
        "
            @click="close"
          ></span>
          <div class="form_box" style="width: 100%;">
            <div class="form" style="display: block;padding: 0 15px;">
              <!-- 添加方式 -->
              <div class="col">
                <div class="left" style="flex:none;">
                  <span>*&nbsp;</span> 添加方式
                </div>
                <div class="right" style="padding-top: 5px;">
                  <el-radio v-model="name_c" label="1">手机号码</el-radio>
                  <el-radio v-model="name_c" label="0">邀请链接</el-radio>
                </div>
              </div>
              <!-- 手机号码 -->
              <div class="col" v-show="name_c == '1' ? true : false">
                <div class="left" style="flex:none;">
                  <span>*&nbsp;</span> 手机号码
                </div>
                <div class="right right_" style="position: relative;">
                  <el-input
                    v-model="phone"
                    placeholder="请输入正确的手机号码"
                  ></el-input>
                  <!-- <i
                    style="position: absolute;left: 270px;top: 9px;color: #868E99;cursor: pointer;"
                    class="el-icon-search"
                    @click="search"
                  ></i> -->
                  <div
                    v-show="search_show"
                    style="
                width: 300px;height: 60px;
                border: 1px solid #ECEFF2;
                box-sizing: border-box;
                border-radius: 2px;
                display: flex;
                padding: 10px 20px;
                margin-top: 8px;
                overflow: hidden;
                margin-bottom: 20px;
                "
                  >
                    <div
                      style="border-radius: 50%;overflow: hidden;margin-right: 15px;"
                    >
                      <img
                        style="width: 40px;height: 40px;object-fit: cover;"
                        src="../../../assets/images/crm/tx.jpg"
                        alt=""
                      />
                    </div>
                    <div style="width: 165px;">
                      <p style="font-size: 14px;color: #0A101E;">
                        {{ search_user.name || "" }}
                      </p>
                      <span style="font-size: 12px;color:#868E99">{{
                        search_user.phone || ""
                      }}</span>
                    </div>
                    <div
                      v-show="addShow"
                      @click="add_user"
                      style="width: 46px;height: 20px;
                font-size: 12px;color: #fff;
                background-color: #5B85FF;   
                border-radius: 2px;
                margin-top: 10px;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
                "
                    >
                      添加
                    </div>
                    <div
                      v-show="!addShow"
                      style="width: 46px;height: 20px;
                font-size: 12px;color: #fff;
                background-color: #5B85FF;   
                border-radius: 2px;
                margin-top: 10px;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
                "
                    >
                      已添加
                    </div>
                  </div>
                </div>
              </div>

              <!-- 已添加 -->
              <div
                class="col"
                v-show="name_c == '1' && userList.length > 0 ? true : false"
              >
                <div class="left" style="flex: none;margin-left: 30px;">
                  已添加
                </div>
                <div class="right">
                  <div class="child" style="overflow: hidden;">
                    <li
                      v-for="(item, index) in userList"
                      :key="index"
                      style="width: 93px;
                  height: 108px;float: left;
                  margin-right: 10px;
                  box-sizing: border-box;
                  border-radius: 2px;
                  border: 1px solid #ECEFF2;
                  list-style: none;
                  margin-bottom: 10px;
                  text-align: center;
                  "
                    >
                      <img
                        style="width: 40px;height: 40px;margin-top: 16px;object-fit: cover;"
                        src="../../../assets/images/crm/tx.jpg"
                        alt=""
                      />
                      <p
                        style="font-size: 14px;color: #0A101E;line-height: 15px;"
                      >
                        {{ item.name }}
                      </p>
                      <span style="font-size: 12px;color: #868E99;">{{
                        item.phone
                      }}</span>
                    </li>
                  </div>
                </div>
              </div>

              <!-- 管理权限 -->
              <div class="col">
                <div class="left" style="flex:none;">
                  <span>*&nbsp;</span> 管理权限
                </div>
                <div class="right">
                  <el-checkbox-group v-model="checkList" style="width: auto;">
                    <el-checkbox
                      v-for="(item, index) in checkItem"
                      :key="index"
                      :label="item.name"
                      style="width: 100px;margin-top: 6px;"
                    ></el-checkbox>
                  </el-checkbox-group>
                  <!-- <el-checkbox v-model="checked"  label='全选' style="width: 23%;"></el-checkbox> -->
                </div>
              </div>

              <!-- <div class="col">
                <div class="left" style="flex: none;margin-top: 0;">
                  <span>*&nbsp;</span> 合作方设置
                
                </div>
                <div class="right">
                  <div style="margin-bottom: 20px;">
                    <el-radio v-model="radio" label="checkedAll"
                      >全部合作方</el-radio
                    >
                    <el-radio v-model="radio" label="checked"
                      >指定合作方</el-radio
                    >
                  </div>
                  <div
                    style="flex:1;display:flex;margin-bottom: 25px;"
                    class="AZ"
                  >
                    <li
                      v-show="listShow"
                      :class="{ liActive: active1 == 'all' }"
                      @click="mouseover1"
                      style="font-size: 14px;padding: 0 7px;cursor: pointer;"
                    >
                      全部
                    </li>
                    <li
                      v-show="listShow"
                      :class="{ liActive: active1 == item }"
                      @click="mouseover2(item)"
                      v-for="(item, index) in A_Z"
                      :key="index"
                      style="font-size: 14px;padding: 0 5px;margin-left: 3px;cursor: pointer;"
                    >
                      {{ item }}
                    </li>
                  </div>
                  <div
                    class="LogoBox"
                    v-show="listShow"
                    :style="{
                      minHeight: '60px',
                      maxHeight: '177px',
                      overflowY: 'auto',
                      marginBottom: '30px',
                      display: 'flex',
                    }"
                  >
                    <a
                      v-for="(item, index) in listArr"
                      @click="
                        invClick(item.id, item.simpleName, item.selected, index)
                      "
                      :class="{ li_active: item.selected }"
                    >
                      <img
                        style="width: 100px;height: 53px;margin-top: 4px;"
                        v-if="item.selfImage && item.type == 0"
                        :src="api + item.selfImage"
                        alt=""
                      />
                      <div
                        style="display: flex;align-items: center;justify-content: center;"
                      >
                        <img
                          style="width: 26px;height: 26px;border-radius: 50%;margin-right: 10px;"
                          v-if="item.selfImage && item.type == 1"
                          :src="api + item.selfImage"
                          alt=""
                        />
                        <span>{{ item.simpleName }}</span>
                      </div>
                      <span v-if="!item.selfImage">{{ item.simpleName }}</span>
                      <p>{{ item.simpleName }}</p>
                      <i
                        v-show="item.selected"
                        style="font-size: 18px;position: absolute;color: #5B85FF;z-index: 100;top: -24px;right: -5px;"
                        class="iconfont icon-dui"
                      ></i>
                    </a>
                  </div>
                  <div class="choice_T" v-show="listShow">
                    <p>已选择合作方：</p>
                    <el-checkbox
                      v-for="(item, index) in activeList"
                      :key="item.id"
                      v-model="item.checked"
                      @change="cheBtn(item)"
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </div> -->

              <!-- 邀请链接 -->
              <div class="col" v-show="name_c == '0' ? true : false">
                <div class="left" style="flex: none;">
                  <span>*&nbsp;</span> 邀请链接
                </div>
                <div class="right" style="width: 300px;">
                  <p style="font-size: 13px;color: #181E2D;line-height: 35px;">
                    复制链接邀请管理员认证加入，和我们共同管理投顾
                  </p>
                  <div
                    @click="addUrl"
                    style="width: 60px;height: 20px;text-align: center;line-height: 20px;color: #fff;background-color: #62DCB5;
                  border-radius: 2px;font-size: 12px;cursor: pointer;margin-bottom: 15px;"
                  >
                    生成链接
                  </div>
                  <div
                    v-show="url_show"
                    style="display: flex;height: 36px;background-color: #F6F9FF;margin-bottom: 10px;width: 300px;"
                  >
                    <p
                      style="height: 36px;line-height: 36px;flex: 3;white-space: nowrap;overflow: hidden;box-sizing: border-box;padding: 0 10px;text-overflow:ellipsis;font-size: 14px;color: #181E2D;"
                    >
                      {{ url_text }}
                    </p>
                    <div
                      @click="copy"
                      style="flex: 1;font-size: 14px;color: #fff;line-height: 36px;text-align: center;background-color: #5B85FF;cursor: pointer;"
                    >
                      点击复制
                    </div>
                  </div>
                  <span
                    v-show="url_show"
                    style="color: #FF5A44;font-size: 12px;"
                    >*注意：此链接将于3天后过期</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="form_btn" style="justify-content: space-evenly;">
            <!-- <button @click="close">取消</button> -->
            <button v-if="name_c == '1' ? true : false" @click="add_sbumit">
              提交
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in-linear">
      <!-- 权限修改遮罩层 -->
      <div class="popContainer" v-show="qx_show">
        <div
          class="add"
          :style="{
            width: dialogWidth,
            top: 0,
            transform: 'translate(-50%, -300px) !important'
          }"
        >
          <div class="close"></div>
          <div class="Top" :style="{ width: dialogWidth }">
            {{ editTitle }}
          </div>
          <span
            class="close iconfont icon-close_round_fill_bold
        "
            @click="qx_close"
          ></span>
          <div class="form_box" style="width: 100%;min-height: 130px;">
            <div
              class="form"
              style="display: block;min-height: 130px;padding: 0 20px;"
            >
              <!-- 管理权限 -->
              <div class="col" v-if="type == '3'">
                <div class="left" style="flex: none;margin-top: 0;">
                  <span>*&nbsp;</span> 管理权限
                </div>
                <div class="right">
                  <el-checkbox-group v-model="checkList" style="width: auto;">
                    <el-checkbox
                      v-for="(item, index) in checkItem"
                      :key="index"
                      :label="item.name"
                      style="width:100px;"
                    ></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>

              <div class="col" v-if="type == '4'">
                <!-- <div class="left" style="flex: none;margin-top: 0;">
                  <span>*&nbsp;</span> 合作方设置
                </div> -->
                <div class="right">
                  <div style="margin-bottom: 20px;">
                    <el-radio v-model="radio" label="checkedAll"
                      >全部合作方</el-radio
                    >
                    <el-radio v-model="radio" label="checked"
                      >指定合作方</el-radio
                    >
                  </div>
                  <div
                    style="flex:1;display:flex;margin-bottom: 25px;"
                    class="AZ"
                  >
                    <li
                      v-show="listShow"
                      :class="{ liActive: active1 == 'all' }"
                      @click="mouseover1"
                      style="font-size: 14px;padding: 0 7px;cursor: pointer;"
                    >
                      全部
                    </li>
                    <li
                      v-show="listShow"
                      :class="{ liActive: active1 == item }"
                      @click="mouseover2(item)"
                      v-for="(item, index) in A_Z"
                      :key="index"
                      style="font-size: 14px;padding: 0 5px;margin-left: 3px;cursor: pointer;"
                    >
                      {{ item }}
                    </li>
                  </div>
                  <div
                    class="LogoBox"
                    v-show="listShow"
                    :style="{
                      minHeight: '60px',
                      maxHeight: '177px',
                      overflowY: 'auto',
                      marginBottom: '30px',
                      display: 'flex'
                    }"
                  >
                    <a
                      v-for="(item, index) in listArr"
                      @click="
                        invClick(item.id, item.simpleName, item.selected, index)
                      "
                      :key="index"
                      :class="{ li_active: item.selected }"
                    >
                      <img
                        style="width: 100px;height: 53px;margin-top: 4px;"
                        v-if="item.selfImage && item.type == 0"
                        :src="api + item.selfImage"
                        alt=""
                      />
                      <div
                        style="display: flex;align-items: center;justify-content: center;"
                      >
                        <img
                          style="width: 26px;height: 26px;border-radius: 50%;margin-right: 10px;"
                          v-if="item.selfImage && item.type == 1"
                          :src="api + item.selfImage"
                          alt=""
                        />
                        <span>{{ item.simpleName }}</span>
                      </div>
                      <span v-if="!item.selfImage">{{ item.simpleName }}</span>
                      <p>{{ item.simpleName }}</p>
                      <i
                        v-show="item.selected"
                        style="font-size: 18px;position: absolute;color: #5B85FF;z-index: 100;top: -24px;right: -5px;"
                        class="iconfont icon-dui"
                      ></i>
                    </a>
                  </div>
                  <div class="choice_T" v-show="listShow">
                    <p>已选择合作方：</p>
                    <el-checkbox
                      v-for="(item, index) in activeList"
                      :key="item.id"
                      v-model="item.checked"
                      @change="cheBtn(item)"
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </div>

              <div v-if="type == '5'">
                <el-radio v-model="userType" label="1">全部账号</el-radio>
                <el-radio v-model="userType" label="2">指定账号</el-radio>
              </div>

              <div
                v-if="type == '5' && userType == '2'"
                class="searchUserBox searchBox"
              >
                <el-input
                  v-model="userSearch"
                  placeholder="请输入账户"
                ></el-input>
                <el-input
                  v-model="nameSearch"
                  placeholder="请输入姓名"
                ></el-input>
                <input
                  class="btn"
                  type="button"
                  style="margin-top: 15px;"
                  @click="searchBtn"
                  value="搜索"
                />
                <input
                  style="color: #fff;background-color: #5B85FF;margin-top: 15px;"
                  class="btn"
                  @click="resetBtn"
                  type="reset"
                  value="重置"
                />
              </div>

              <div
                v-if="type == '5' && userType == '2'"
                class="table"
                style="margin-top: 40px;"
              >
                <el-table
                  max-height="400"
                  border
                  :data="resList"
                  size="medium"
                  style="width: 100%"
                  :header-cell-style="{ textAlign: 'center' }"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column width="50" :render-header="renderHeader">
                    <template slot-scope="scope">
                      <el-checkbox
                        @change="checkBtn(scope.row.checked, scope.row.id)"
                        v-model="scope.row.checked"
                      ></el-checkbox>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" prop="userCode" label="账户">
                  </el-table-column>
                  <el-table-column prop="userName" label="姓名" align="center">
                  </el-table-column>

                  <el-table-column
                    prop="shareMoney"
                    align="right"
                    label="累计分红"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.shareMoney | format }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sumNet"
                    width="80"
                    align="right"
                    label="净值"
                  >
                    <template slot-scope="scope">
                      <span
                        :style="{
                          color: scope.row.sumNet > 1 ? '#FA5D22' : '#3ABA94'
                        }"
                        >{{ scope.row.sumNet | num3 }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="simpleName"
                    label="合作方名称"
                    align="center"
                  >
                  </el-table-column>

                  <el-table-column
                    prop="contractNum"
                    label="合作编号"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div v-if="type != '5'" class="form_btn">
            <!-- <button @click="qx_close">取消</button> -->
            <button @click="qx_submit">提交</button>
          </div>
          <div v-if="type == '5'" class="form_btn">
            <!-- <button @click="qx_close">取消</button> -->
            <button @click="userSubmit">提交</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in-linear">
      <!-- 权限选择遮罩层 -->
      <div class="popContainer" v-show="sp_show">
        <div class="add" :style="{ width: '1000px' }">
          <div class="close"></div>
          <div class="Top" :style="{ width: '1000px' }">
            权限选择
          </div>
          <span
            class="close iconfont icon-close_round_fill_bold
        "
            @click="sp_close"
          ></span>
          <div class="form_box" style="width: 100%;">
            <div
              class="form"
              style="display: block;min-height: 230px;padding: 0 15px;"
            >
              <!-- 管理权限 -->
              <div class="col">
                <div class="left" style="flex: none;margin-top: 0;">
                  <span>*&nbsp;</span> 管理权限
                </div>
                <div class="right">
                  <el-checkbox-group
                    true-label
                    v-model="checkList"
                    style="width: auto;"
                  >
                    <el-checkbox
                      v-for="(item, index) in checkItem"
                      :key="index"
                      :label="item.name"
                      style="width: 100px;"
                    ></el-checkbox>
                  </el-checkbox-group>
                  <!-- <el-checkbox v-model="checked"  label='全选' style="width: 23%;"></el-checkbox> -->
                </div>
              </div>
              <!-- 
              <div class="col">
                <div class="left" style="flex: none;margin-top: 0;">
                  <span>*&nbsp;</span> 数据权限
            
                </div>
                <div class="right">
                  <div style="margin-bottom: 20px;">
                    <el-radio v-model="radio" label="checkedAll"
                      >全部合作方</el-radio
                    >
                    <el-radio v-model="radio" label="checked"
                      >指定合作方</el-radio
                    >
                  </div>
                  <div
                    style="flex:1;display:flex;margin-bottom: 25px;"
                    class="AZ"
                  >
                    <li
                      v-show="listShow"
                      :class="{ liActive: active1 == 'all' }"
                      @click="mouseover1"
                      style="font-size: 14px;padding: 0 7px;cursor: pointer;"
                    >
                      全部
                    </li>
                    <li
                      v-show="listShow"
                      :class="{ liActive: active1 == item }"
                      @click="mouseover2(item)"
                      v-for="(item, index) in A_Z"
                      :key="index"
                      style="font-size: 14px;padding: 0 5px;margin-left: 3px;cursor: pointer;"
                    >
                      {{ item }}
                    </li>
                  </div>
                  <div
                    class="LogoBox"
                    v-show="listShow"
                    :style="{
                      minHeight: '60px',
                      maxHeight: '177px',
                      overflowY: 'auto',
                      marginBottom: '30px',
                      display: 'flex',
                    }"
                  >
                    <a
                      v-for="(item, index) in listArr"
                      @click="
                        invClick(item.id, item.simpleName, item.selected, index)
                      "
                      :class="{ li_active: item.selected }"
                    >
                      <img
                        style="width: 100px;height: 53px;margin-top: 4px;"
                        v-if="item.selfImage && item.type == 0"
                        :src="api + item.selfImage"
                        alt=""
                      />
                      <div
                        style="display: flex;align-items: center;justify-content: center;"
                      >
                        <img
                          style="width: 26px;height: 26px;border-radius: 50%;margin-right: 10px;"
                          v-if="item.selfImage && item.type == 1"
                          :src="api + item.selfImage"
                          alt=""
                        />
                        <span>{{ item.simpleName }}</span>
                      </div>
                      <span v-if="!item.selfImage">{{ item.simpleName }}</span>
                      <p>{{ item.simpleName }}</p>
                      <i
                        v-show="item.selected"
                        style="font-size: 18px;position: absolute;color: #5B85FF;z-index: 100;top: -24px;right: -5px;"
                        class="iconfont icon-dui"
                      ></i>
                    </a>
                  </div>
                  <div class="choice_T" v-show="listShow">
                    <p>已选择投顾：</p>
                    <el-checkbox
                      v-for="(item, index) in activeList"
                      :key="item.id"
                      v-model="item.checked"
                      @change="cheBtn(item)"
                      >{{ item.name }}</el-checkbox
                    >
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="form_btn">
            <button
              @click="noBtn"
              style="color: #5b85ff;background-color: #fff;"
            >
              拒绝
            </button>
            <button
              @click="agree"
              style="border-radius: 2px;
            cursor: pointer;
            width: 80px;
            height: 34px;
            box-sizing: border-box;
            text-align: center;
            background-color: #5b85ff;
            color: #fff;
            font-size: 16px;
            border: 1px solid #5b85ff !important;
            "
            >
              同意
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import hhead from "../header/index";
import crmNav from "../../../components/crmNav/index";
import "./style.css";
export default {
  components: { hhead, crmNav },
  data() {
    return {
      dialogWidth: "1000px",
      editTitle: "",
      checkedTrue: true,
      AZ: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      userType: "1", //账户设置类型 1全部账号 2指定账号
      userSearch: "", //账号搜索
      nameSearch: "", //名称搜索
      resList: [],
      arrId: [], //保存的本地ID
      logLevel: false,
      add: "", //投顾标签选中样式
      A_Z: [],
      list: [], //列表信息
      listArr: [],
      listShow: false,
      MHeight: document.documentElement.clientHeight - 94 + "px",
      active: "1",
      active1: "all",
      t_list: "",
      radio: "", //选择全部投顾 指定投顾
      api: this.$store.state.api,
      admin: false,
      name_c: "1",
      checkList: [], //已选择权限
      value: "", // 已选择权限的value
      checkItem: [], //所有权限
      checked: false, //投顾选择
      phone: "", //手机号
      search_user: "", //搜索到的用户信息
      url_text: "", //生成的链接
      qx_show: false, // 权限修改显示
      sp_show: false, //审批权限选择
      search_show: false, //手机号搜索用户信息 有则显示
      userList: [], //邀请管理员当前已添加
      spList: "", //审批列表
      spId: "", //当前审批管理员的ID
      qxId: "",
      addShow: true,
      res: "",
      url_show: false, //生成链接之后为true
      All: true, //是否全选
      borderColor: "", //邀请边框颜色
      iColor: "", //加号颜色
      qxShow: false, //权限显示
      activeList: [], //已选中投顾
      type: "" //  3管理权限 4合作方权限
    };
  },
  filters: {
    format: function(n) {
      if (n) {
        return Math.round(n / 10000);
      } else {
        return "0";
      }
    },

    num3: function(n) {
      if (n) {
        return n.toFixed(4);
      }
    }
  },
  mounted() {
    if (this.$route.query.active) {
      this.apply();
    }
    this.teamList();
    this.res = JSON.parse(localStorage.getItem("res")) || "";
    // console.log(this.res);
  },

  methods: {
    cheBtn(e) {
      this.activeList.forEach((item, index) => {
        if (item.id == e.id) {
          this.activeList.splice(index, 1);
        }
      });
      this.listArr.forEach((eve, i) => {
        if (eve.id == e.id) {
          this.listArr[i].selected = false;
        }
      });
    },
    invClick(id, name, selected, i) {
      //控制多选投顾标签
      if (this.listArr[i].selected) {
        this.activeList.forEach((item, index) => {
          if (item.id == id) {
            this.activeList.splice(index, 1);
          }
        });
      } else {
        this.activeList.push({ id: id, name: name, checked: true });
      }
      this.listArr[i].selected = !selected;

      //   console.log(this.activeList);
    },
    mouseover2(e) {
      //字母移入事件

      this.active1 = e;
      let arr = [];
      let pinyin = require("js-pinyin");
      pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
      this.list.inv.forEach(item => {
        if (e == pinyin.getFullChars(item.simpleName).substr(0, 1)) {
          arr.push(item);
        }
      });
      this.listArr = arr;
      if (this.listArr.length <= 11) {
        this.LogoHeight = "60px";
      }
    },
    mouseover1() {
      this.active1 = "all";
      this.listArr = this.list.inv;
      //   console.log(this.list);
      this.LogoHeight = "177px";
    },
    clear() {
      //清除数据专用
      this.userList = [];
      this.checkList = [];
      this.radio = "";
      this.phone = "";
      this.checkItem = [];
      this.search_user = "";
      this.activeList = [];
      this.search_show = false;
      this.admin = false;
      this.qx_show = false;
      this.url_text = "";
      this.url_show = false;
      this.logLevel = false;
    },
    add_sbumit() {
      //邀请提交

      this.val();
      if (this.name_c == "1") {
        let userId = ""; //选择的用户ID传值
        this.userList.forEach(item => {
          userId += "," + item.id;
        });
        var invId = "";
        this.activeList.forEach(item => {
          invId += "," + item.id;
        });
        this.$axios
          .post(
            //   '/crm/mem/savaMemAndModule'
            "/crm/mem/savaMemAndModuleTwo",
            {
              apiToken: this.$store.state.usermsg.apiToken,
              // customerIds: userId.replace(',', ''),
              modules: this.value,
              phoneNum: this.phone,
              choseInverstor: false,
              inverstorIds: invId.replace(",", "")
            }
          )
          .then(res => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.clear();
              this.$alert(`邀请成功`, {
                confirmButtonText: "确定",
                type: "success",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      }
      if (this.name_c == "0") {
      }
    },

    del_btn(name, id) {
      // 删除成员
      this.$axios
        .post("/crm/mem/queryGroupingMems", {
          apiToken: this.$store.state.usermsg.apiToken,
          emId: id
        })
        .then(r => {
          this.$confirm(
            `${
              r.data.code == 200
                ? "成员" + "“" + name + "”" + "已绑定投资经理，确定删除吗"
                : "确定删除成员" + "“" + name + "”" + "吗"
            }`,
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
            }
          )
            .then(() => {
              this.$axios
                .post("/crm/mem/del", {
                  apiToken: this.$store.state.usermsg.apiToken,
                  emId: id
                })
                .then(res => {
                  // console.log(res);
                  this.tokenInvalid(res);
                  if (res.data.code == 200) {
                    this.teamList();
                    this.clear();

                    // this.$alert('删除成功', {
                    //   confirmButtonText: '确定',
                    //   type: 'success',
                    //   center: true,
                    // })
                    //   .then(() => {

                    //   })
                    //   .catch(() => {});
                  } else {
                    this.$alert(res.data.message, {
                      confirmButtonText: "确定",
                      type: "error",
                      center: true
                    })
                      .then(() => {})
                      .catch(() => {});
                  }
                });
            })
            .catch(() => {});
        });
    },
    sp_btn(id, emId) {
      // 点击审批
      //   console.log(id, emId);
      this.sp_show = true;
      this.spId = emId;

      this.$axios
        .post("/crm/mem/queryAllModel", {
          apiToken: this.$store.state.usermsg.apiToken
          //   customerId: id,
        })
        .then(res => {
          //   console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            res.data.data.model.forEach(item => {
              this.checkItem.push(item);

              if (item.selected) {
                this.checkList.push(item.name);
              }
            });

            res.data.data.inv.forEach(item => {
              if (item.selected) {
                this.activeList.push({
                  id: item.id,
                  name: item.simpleName,
                  checked: true
                });
              }
            });

            let arr = [];
            let pinyin = require("js-pinyin");
            pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
            res.data.data.inv.forEach(item => {
              arr.push(pinyin.getFullChars(item.simpleName).substr(0, 1));
            });
            // console.log(arr)
            let str = "";
            arr.forEach(e => {
              if (str.indexOf(e) < 0) {
                str += e.toUpperCase(); //转大写
              }
            });
            this.A_Z = str.split("").sort(); //排序
            if (res.data.data.isChose[0].selected) {
              this.radio = "checkedAll";
            } else if (res.data.data.isChose[1].selected) {
              this.radio = "checked";
            }
            // console.log(
            //   res.data.data.isChose[0].selected,
            //   res.data.data.isChose[1].selected
            // );
            this.list = res.data.data;
            this.listArr = this.list.inv;
          }
        });
      //   this.qxAll();
      //   this.checkList = [
      //     //默认全选
      //     '账户管理',
      //     '注册信息',
      //     '投顾管理',
      //     '数据分析',
      //     '提醒设置',
      //     '合作管理',
      //     '团队成员',
      //   ];
    },
    sp_close() {
      //关闭审批
      this.sp_show = false;
      this.checkItem = [];
      this.clear();
    },
    qx_edit(id, emId, type) {
      //打开权限修改

      this.editTitle =
        type == "3"
          ? "权限设置"
          : type == "4"
          ? "合作方设置"
          : type == "5"
          ? "账号设置"
          : "";
      this.type = type;
      this.dialogWidth =
        type == "3"
          ? "570px"
          : type == "4"
          ? "1000px"
          : type == "5"
          ? "1000px"
          : "1000px";

      this.qxId = emId;
      if (type != "5") {
        this.$axios
          .post("/crm/mem/queryAllModel", {
            apiToken: this.$store.state.usermsg.apiToken,
            customerId: id ? id : ""
          })
          .then(res => {
            if (id) {
              this.qx_show = true;
            }
            //   console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              res.data.data.model.forEach(item => {
                this.checkItem.push(item);

                if (item.selected) {
                  this.checkList.push(item.name);
                }
              });

              res.data.data.inv.forEach(item => {
                if (item.selected) {
                  this.activeList.push({
                    id: item.id,
                    name: item.simpleName,
                    checked: true
                  });
                }
              });

              let arr = [];
              let pinyin = require("js-pinyin");
              pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
              res.data.data.inv.forEach(item => {
                arr.push(pinyin.getFullChars(item.simpleName).substr(0, 1));
              });
              // console.log(arr)
              let str = "";
              arr.forEach(e => {
                if (str.indexOf(e) < 0) {
                  str += e.toUpperCase(); //转大写
                }
              });
              this.A_Z = str.split("").sort(); //排序
              if (res.data.data.isChose[0].selected) {
                this.radio = "checkedAll";
              } else if (res.data.data.isChose[1].selected) {
                this.radio = "checked";
              }
              this.list = res.data.data;
              this.listArr = this.list.inv;
            }
          });
      } else {
        this.$axios
          .post("/crm/mem/queryAcc", {
            apiToken: this.$store.state.usermsg.apiToken,
            memsId: emId
            // investorId: id
            // isEdit:false,
            // page_no: this.page,
            //   size: 10000,
          })
          .then(res => {
            console.log(res);
            if (id) {
              this.qx_show = true;
            }

            if (res.data.code == 200) {
              this.userType = res.data.data.choseAccount ? "2" : "1";
              this.resList = [];
              res.data.data.entAccList.forEach(item => {
                item.isShow = true;

                this.resList.push(item);
              });
              console.log(this.resList);
              // this.resList.forEach(item=>{

              //     this.arrId.forEach(e=>{
              //         if(e==item.id){
              //             item.deleted =true
              //         }
              //     })
              // })
            }
          });
      }
    },

    qx_close() {
      //关闭权限修改按钮
      this.qx_show = false;
      this.clear();
    },
    team() {
      //团队成员按钮
      this.active = "1";
      this.teamList();
    },
    apply() {
      //审批按钮
      this.active = "2";
      this.$axios
        .post("/crm/mem/queryUnCheck", {
          apiToken: this.$store.state.usermsg.apiToken
        })
        .then(res => {
          //   console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.spList = res.data.data;
          }
        });
    },
    //团队成员列表
    teamList() {
      this.$axios
        .post("/crm/mem/queryMems", {
          apiToken: this.$store.state.usermsg.apiToken
        })
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.t_list = res.data.data;
          }
        });
    },
    mouseover() {
      if (this.res.adLevel == 0) {
        this.borderColor = "#5B85FF";
        this.iColor = "#fff";
        this.qxShow = false;
      } else {
        this.borderColor = "";
        this.iColor = "";
        this.qxShow = true;
      }
    },
    mouseleave() {
      this.borderColor = "";
      this.iColor = "";
      this.qxShow = false;
    },
    invitation() {
      ///邀请管理员
      // console.log(111);
      if (this.res.adLevel == 0) {
        this.admin = true;
        this.qx_edit();
        // this.qxAll();
      } else {
        // this.$alert('权限不足', {
        //   confirmButtonText: '确定',
        //   type: 'error',
        //   center: true,
        // })
        //   .then(() => {})
        //   .catch(() => {});
      }
      //   this.checkList = [
      //     //默认全选
      //     '账户管理',
      //     '注册信息',
      //     '投顾管理',
      //     '数据分析',
      //     '提醒设置',
      //     '合作管理',
      //     '团队成员',
      //   ];
    },
    // qxAll(id) {
    //   //所有权限
    //   this.$axios
    //     .post('/crm/mem/queryAllModel', {
    //       apiToken: this.$store.state.usermsg.apiToken,
    //       customerId: id || '',
    //     })
    //     .then((res) => {
    //       //   // console.log(res);
    //       this.tokenInvalid(res);
    //       if (res.data.code == 200) {
    //         res.data.data.model.forEach((item) => {
    //           this.checkItem.push(item);
    //         });
    //       }
    //     });
    // },
    search() {
      //手机号搜索
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.addShow = true;
        this.$axios
          .post("/crm/mem/searcPhone", {
            apiToken: this.$store.state.usermsg.apiToken,
            phoneNum: this.phone
          })
          .then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              this.search_user = res.data.data;
              this.search_show = true;
              if (this.userList.length > 0) {
                this.userList.forEach(item => {
                  if (item.id == this.search_user.id) {
                    this.addShow = false;
                  }
                });
              }
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.search_show = false;
        this.$alert("请输入正确的手机号码", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    val() {
      //取选中value
      let v = "";
      this.checkList.forEach(item => {
        this.checkItem.forEach(i => {
          if (item.indexOf(i.name) != -1) {
            v += "," + i.value;
          }
        });
      });
      this.value = v.replace(",", "");
    },
    addUrl() {
      //生成链接
      if (this.checkList.length > 0) {
        this.val();
        var invId = "";
        this.activeList.forEach(item => {
          invId += "," + item.id;
        });
        // console.log(this.value);
        this.$axios
          .post("/crm/mem/createInviteLink", {
            apiToken: this.$store.state.usermsg.apiToken,
            modules: this.value,
            choseInverstor: this.radio == "checkedAll" ? false : true,
            inverstorIds: invId.replace(",", "")
          })
          .then(res => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.url_show = true;
              this.url_text =
                this.$store.state.url + "/crm/invitation?type=" + res.data.data;
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert("请选择权限", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {
            this.active = "1";
            this.teamList();
          })
          .catch(() => {});
      }
    },
    add_user() {
      //添加管理员
      this.userList.push(this.search_user);
      if (this.userList.length > 0) {
        this.userList.forEach(item => {
          if (item.id == this.search_user.id) {
            this.addShow = false;
          }
        });
      }

      // console.log(this.userList);
    },
    close() {
      //关闭邀请管理员
      this.clear();
    },
    agree() {
      //审批通过
      if (this.radio == "checkedAll") {
        if (this.checkList.length > 0) {
          var invId = "";
          this.activeList.forEach(item => {
            invId += "," + item.id;
          });
          this.val();
          this.$axios
            .post("/crm/mem/checkJoinEnt", {
              state: 1,
              apiToken: this.$store.state.usermsg.apiToken,
              model: this.value,
              emId: this.spId,
              choseInverstor: false,
              choseAccount: false
            })
            .then(res => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.sp_close();
                this.apply();
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        } else {
          this.$alert("请选择权限", {
            confirmButtonText: "确定",
            type: "error",
            center: true
          })
            .then(() => {})
            .catch(() => {});
        }
      }

      if (this.checkList.length > 0) {
        var invId = "";
        this.activeList.forEach(item => {
          invId += "," + item.id;
        });
        this.val();
        this.$axios
          .post("/crm/mem/checkJoinEnt", {
            state: 1,
            apiToken: this.$store.state.usermsg.apiToken,
            model: this.value,
            emId: this.spId,
            choseInverstor: false,
            choseAccount: false,
            inverstorIds: invId.replace(",", "")
          })
          .then(res => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.sp_close();
              this.apply();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert("请选择权限", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    qx_submit() {
      //提交权限修改
      this.val();
      // console.log(this.qxId);
      if (this.radio == "checkedAll") {
        if (this.checkList.length > 0) {
          this.$axios
            .post("/crm/mem/modModule", {
              apiToken: this.$store.state.usermsg.apiToken,
              emId: this.qxId,
              modules: this.value,
              choseInverstor: false
            })
            .then(res => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.clear();
                this.teamList();
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        } else {
          this.$alert("请选择权限", {
            confirmButtonText: "确定",
            type: "error",
            center: true
          })
            .then(() => {})
            .catch(() => {});
        }
      } else if (this.radio == "checked") {
        var invId = "";
        this.activeList.forEach(item => {
          invId += "," + item.id;
        });
        if (this.checkList.length > 0) {
          this.$axios
            .post("/crm/mem/modModule", {
              apiToken: this.$store.state.usermsg.apiToken,
              emId: this.qxId,
              modules: this.value,
              choseInverstor: true,
              inverstorIds: invId.replace(",", "")
            })
            .then(res => {
              //   console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.clear();
                this.teamList();
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        } else {
          this.$alert("请选择权限", {
            confirmButtonText: "确定",
            type: "error",
            center: true
          })
            .then(() => {})
            .catch(() => {});
        }
      } else {
        this.$alert("请选择数据类型", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    noBtn() {
      //审批拒绝
      this.$axios
        .post("/crm/mem/checkJoinEnt", {
          state: 2,
          model: "Enterprise",
          apiToken: this.$store.state.usermsg.apiToken,
          emId: this.spId,
          choseInverstor: false,
          choseAccount: false
        })
        .then(res => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.active = "1";
            this.sp_close();
            this.teamList();
            // this.$alert('审批拒绝', {
            //   confirmButtonText: '确定',
            //   type: 'success',
            //   center: true,
            // })
            //   .then(() => {

            //   })
            //   .catch(() => {});
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
    copy() {
      //复制功能
      let that = this;
      this.$copyText(this.url_text).then(
        function(e) {
          that
            .$alert("复制成功", {
              confirmButtonText: "确定",
              type: "success",
              center: true
            })
            .then(() => {})
            .catch(() => {});
        },
        function(e) {
          that
            .$alert("复制失败", {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
            .then(() => {})
            .catch(() => {});
        }
      );
    },
    searchBtn() {
      //搜索按钮
      this.resList.forEach(item => {
        if (
          item.userCode.indexOf(this.userSearch + "") != -1 &&
          item.userName.indexOf(this.nameSearch + "") != -1
        ) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });
    },
    resetBtn() {
      // 重置按钮
      this.userSearch = "";
      this.nameSearch = "";
      this.searchBtn();
    },
    tableRowClassName(row, index) {
      //表格行

      if (!row.row.isShow) {
        return "hidden-row";
      } else {
        return "";
      }
    },
    renderHeader(h, { column }) {
      return (
        "span",
        [
          h("el-checkbox", {
            on: {
              change: this.select
            },
            props: {
              value: this.logLevel //文字框的内容取决于这个value，如果value不存在，会报错
            }
          }),
          h("span", column.label)
        ]
      );
    },
    select(checked) {
      // 如果checked为true则是勾选了对应的表头
      //   console.log(checked)
      this.logLevel = checked;
      if (this.logLevel) {
        //全选

        this.resList.forEach((item, index) => {
          item.checked = true;
          // if(item.deleted == false){  //判断全选之前没有选中的
          //     this.arrId.push(item.id) //没有选中的ID push到arrId数组
          // }
        });
      } else {
        //全不选
        this.resList.forEach(item => {
          item.checked = false;
          // this.arrId.forEach((e,i)=>{ //从arrId数组里删除未选中的ID
          //     if(e == item.id){
          //         this.arrId.splice(i,1)
          //     }
          // })
        });
      }
      //   console.log(this.arrId)
    },
    checkBtn(e, id) {
      if (e) {
        let i = 0;
        this.resList.forEach(item => {
          if (item.checked) {
            i++;
          }
        });
        if (i == this.resList.length) {
          this.logLevel = true;
        }

        this.arrId.push(id);
      } else {
        this.logLevel = false;
        this.arrId.forEach((item, index) => {
          if (item == id) {
            this.arrId.splice(index, 1);
          }
        });
      }
      //   console.log(this.arrId)
    },
    userSubmit() {
      let id = [];
      this.resList.forEach(item => {
        if (item.checked) {
          id.push(item.id);
        }
      });

      this.$axios
        .post("/crm/mem/accountSetting", {
          apiToken: this.$store.state.usermsg.apiToken,
          accId: id,
          id: this.qxId,
          choseAccount: this.userType == "2" ? true : false
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.clear();
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    }
  },
  watch: {
    radio(e) {
      // console.log(e);
      if (e == "checked") {
        this.listShow = true;
      }
      if (e == "checkedAll" || !e) {
        this.listShow = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/crm/team/index.vue